<template>
    <div class="row row-xs">
        <div class="col-md-6 col-xl-4 mg-t-10">
            <div class="card ht-100p">
                <div class="card-header d-flex align-items-center justify-content-between">
                    <h6 class="mg-b-0">Transaction History</h6>
                    <div class="d-flex tx-18">
                        <a href="" class="link-03 lh-0"><i class="icon ion-md-refresh"></i></a>
                        <a href="" class="link-03 lh-0 mg-l-10"><i class="icon ion-md-more"></i></a>
                    </div>
                </div>
                <ListItem :transitems="this.account.allActivities.slice(0, 5)"/>
                <div class="card-footer text-center tx-13">
                    <router-link :to="{ name: 'AccountActivities'}" class="link-01">View More Transactions <i class="icon ion-md-arrow-down mg-l-5"></i></router-link>
                </div><!-- card-footer -->
            </div><!-- card -->
        </div>
        <div class="col-md-6 col-xl-4 mg-t-10">
            <div class="card ht-100p">
                <div class="card-header d-flex align-items-center justify-content-between">
                    <h6 class="mg-b-0">Beneficiaries</h6>
                    <div class="d-flex align-items-center tx-18">
                        <a href="" class="link-03 lh-0"><i class="icon ion-md-refresh"></i></a>
                        <a href="" class="link-03 lh-0 mg-l-10"><i class="icon ion-md-more"></i></a>
                    </div>
                </div>
                <BeneficiaryList :benlist="this.account.allActivities.slice(0,5)"/>
                <div class="card-footer text-center tx-13">
                    <router-link :to="{ name: 'AccountActivities'}" class="link-01">View More Benefeciaries <i class="icon ion-md-arrow-down mg-l-5"></i></router-link>
                </div><!-- card-footer -->
            </div><!-- card -->
        </div>
        <div class="col-md-6 col-xl-4 mg-t-10">
            <div class="card ht-100p">
                <div class="card-header d-flex align-items-center justify-content-between">
                    <h6 class="mg-b-0">Airtime Transactions</h6>
                    <div class="d-flex align-items-center tx-18">
                        <a href="" class="link-03 lh-0"><i class="icon ion-md-refresh"></i></a>
                        <a href="" class="link-03 lh-0 mg-l-10"><i class="icon ion-md-more"></i></a>
                    </div>
                </div>
                <AirtimeList :airtimelist="this.account.allActivities.filter(acc => acc.trntype === 'AIRTIME').slice(0,5)"/>
                <div class="card-footer text-center tx-13">
                    <router-link :to="{ name: 'AccountActivities'}" class="link-01">View More Airtime Transactions <i class="icon ion-md-arrow-down mg-l-5"></i></router-link>
                </div><!-- card-footer -->
            </div><!-- card -->
        </div>
    </div>
</template>

<script>
    import ListItem from "./ListItem";
    import {mapState} from "vuex"
    import BeneficiaryList from "./BeneficiaryList";
    import AirtimeList from "./AirtimeList";

    export default {
        name: "History",
        components:{
            AirtimeList,
            BeneficiaryList,
            ListItem
        },
        data:()=>{
            return{
                revenueData: {
                    labels: ['VueJs', 'EmberJs', 'ReactJs', 'AngularJs'],
                    datasets: [
                        {
                            backgroundColor: [
                                '#41B883',
                                '#E46651',
                                '#00D8FF',
                                '#DD1B16'
                            ],
                            data: [40, 20, 80, 10]
                        }
                    ]
                },
                revenueOptions: {
                    responsive: true,
                    maintainAspectRatio: false
                },
            }
        },
        computed:{
            ...mapState(['account'])
        }
    }
</script>

